// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__22kN7"};